/**
 * notificacoesStore — Notificações dinâmicas do usuário (Phase 11.12).
 *
 * Store simples em LocalStorage `notif_dinamicas_v1`. Convive com as
 * notificações mock em `mockData.NOTIFICACOES` — no Header combinamos as
 * duas fontes (dinâmicas em cima, mock embaixo).
 *
 * Formato:
 *   { id, tipo: "alerta"|"sucesso"|"evento"|"atraso"|"consumo",
 *     titulo, descricao, tempo (label), created_at, lida }
 */
const LS_KEY = "notif_dinamicas_v1";
const MAX = 30;

function safeRead() {
  try {
    if (typeof window === "undefined") return [];
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}

function safeWrite(list) {
  try {
    window.localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, MAX)));
    window.dispatchEvent(new Event("notifs:updated"));
  } catch { /* noop */ }
}

export function getNotifs() {
  return safeRead();
}

export function addNotif(n) {
  const list = safeRead();
  const withId = {
    ...n,
    id: n.id || `dn-${Date.now()}`,
    created_at: n.created_at || new Date().toISOString(),
    lida: false,
  };
  // Dedup por "chave" opcional (evita duplicar "Consumo Val 79%" 3x no mesmo dia)
  if (n.chave_dedup) {
    const dupIdx = list.findIndex(x => x.chave_dedup === n.chave_dedup);
    if (dupIdx >= 0) list.splice(dupIdx, 1);
  }
  list.unshift(withId);
  safeWrite(list);
  return withId;
}

export function markAllRead() {
  const list = safeRead().map(n => ({ ...n, lida: true }));
  safeWrite(list);
}

export function countUnread() {
  return safeRead().filter(n => !n.lida).length;
}

/** Formata a "distância" temporal do ISO em pt-BR (aproximado). */
export function relativeLabel(iso) {
  try {
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const min = Math.floor(diff / 60000);
    if (min < 1)   return "agora";
    if (min < 60)  return `${min} min atrás`;
    const h = Math.floor(min / 60);
    if (h < 24)    return `${h} h atrás`;
    const d = Math.floor(h / 24);
    return `${d} d atrás`;
  } catch { return ""; }
}
